import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'ostdurata'
})

export class OstDurataPipe implements PipeTransform {
    /**
     * setta le ore della durata
     * @param  {number} value
     */
    transform(value: number): string {
        let durata: string = '<i class="clock outline icon" title="Durata"></i>'  + (value == null ? '0' : value.toString()) + ' ore';
        return durata;
    }
}